import React, { Component } from 'react';
import Container from '../../v2/container';
import LocationPairList from './LocationPairList';
import List from './List';
export default class extends Component {
    render() {
        return (React.createElement(Container, { className: "py-10" },
            React.createElement("div", { className: "mb-6" },
                React.createElement(LocationPairList, null)),
            React.createElement(List, null)));
    }
}
